module.exports = __webpack_public_path__ + "img/pic-books.63f87d0.svg";